import { useState } from "react";
import { X, Check, ChefHat } from "lucide-react";
import { UNITS, RAYONS } from "@/lib/api";
import { IMPORT_IDS } from "@/constants/testIds/meal";

export default function ValidateIngredientsModal({ data, onCancel, onConfirm }) {
  const [recipeName, setRecipeName] = useState(data.recipe_name);
  const [items, setItems] = useState(
    data.ingredients.map((i, idx) => ({ ...i, _id: idx, _keep: true }))
  );

  const updateItem = (id, patch) => {
    setItems((prev) => prev.map((it) => (it._id === id ? { ...it, ...patch } : it)));
  };

  const handleConfirm = () => {
    const kept = items
      .filter((i) => i._keep && i.name.trim())
      .map(({ _id, _keep, ...rest }) => ({
        ...rest,
        quantity: parseFloat(rest.quantity) || 0,
      }));
    onConfirm(recipeName.trim() || "Recette", kept);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-8 bg-black/40 backdrop-blur-sm">
      <div
        data-testid={IMPORT_IDS.validateModal}
        className="chibi-card w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col chibi-pop"
      >
        <div className="flex items-center justify-between p-6 border-b border-[#E8E2D2]">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "#A3B18A" }}>
              <ChefHat className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="font-display font-semibold text-xl text-[#4A3F35]">Validation des ingrédients</h3>
              <p className="text-sm text-[#4A3F35]/60">Coche, ajuste, valide ✨</p>
            </div>
          </div>
          <button onClick={onCancel} className="p-2 rounded-full hover:bg-[#F4F1EA]">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6 space-y-4 overflow-y-auto flex-1">
          <div>
            <label className="text-sm font-semibold text-[#4A3F35]/70 mb-2 block">Nom de la recette</label>
            <input
              className="chibi-input"
              value={recipeName}
              onChange={(e) => setRecipeName(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            {items.map((it) => (
              <div
                key={it._id}
                className={`flex flex-col md:flex-row md:items-center gap-3 p-4 rounded-[24px] border-2 transition-colors ${
                  it._keep ? "border-[#A3B18A]/30 bg-[#A3B18A]/5" : "border-[#E8E2D2] bg-[#F4F1EA]/40 opacity-60"
                }`}
              >
                <input
                  type="checkbox"
                  checked={it._keep}
                  onChange={(e) => updateItem(it._id, { _keep: e.target.checked })}
                  className="chibi-checkbox"
                />
                <input
                  className="chibi-input flex-1 !py-2 !px-4"
                  value={it.name}
                  onChange={(e) => updateItem(it._id, { name: e.target.value })}
                />
                <input
                  type="number"
                  step="0.1"
                  className="chibi-input w-full md:w-24 !py-2 !px-4"
                  value={it.quantity}
                  onChange={(e) => updateItem(it._id, { quantity: e.target.value })}
                />
                <select
                  className="chibi-input w-full md:w-32 !py-2 !px-4"
                  value={it.unit}
                  onChange={(e) => updateItem(it._id, { unit: e.target.value })}
                >
                  {UNITS.map((u) => (
                    <option key={u} value={u}>{u}</option>
                  ))}
                </select>
                <select
                  className="chibi-input w-full md:w-44 !py-2 !px-4"
                  value={it.rayon}
                  onChange={(e) => updateItem(it._id, { rayon: e.target.value })}
                >
                  {RAYONS.map((r) => (
                    <option key={r} value={r}>{r}</option>
                  ))}
                </select>
              </div>
            ))}
          </div>
        </div>

        <div className="p-6 border-t border-[#E8E2D2] flex gap-3 justify-end">
          <button data-testid={IMPORT_IDS.validateCancel} onClick={onCancel} className="chibi-btn-ghost">
            Annuler
          </button>
          <button
            data-testid={IMPORT_IDS.validateConfirm}
            onClick={handleConfirm}
            className="chibi-btn-primary inline-flex items-center gap-2"
          >
            <Check className="w-5 h-5" /> Ajouter à la liste
          </button>
        </div>
      </div>
    </div>
  );
}
